import { ColumnFilterProps } from "../../types/filters";
import { EnumName } from "../../utils/enums";
import { OptionsListFilter } from "./OptionsListFilter";

export const WasteTypesFilter: React.FC<ColumnFilterProps> = (props) => {
  // TODO: This should be fetched from the backend - EWA-420
  const options = [1, 2, 3, 4, 6, 7, 8, 10];
  const optionsSelectorValue = () => options;

  return <OptionsListFilter enumName={EnumName.WasteTypes} optionsSelectorValue={optionsSelectorValue} {...props} />;
};
